import { EmblaOptionsType } from 'embla-carousel';
import React from 'react';

// import { useSiteContext } from '@zooplus/commons-lang';
import { H2, CarouselBeta, CarouselSlideBeta } from '@zooplus/ui-components';

import { ENV } from '../../environment';
import { useTranslation } from '../../hooks/use-translations';

import { PetsItem } from './pets-item/PetsItem';
import styles from './PetsFamily.module.scss';

const PetsFamily = ({ type }) => {
  const { t } = useTranslation();
  // const { site } = useSiteContext();
  const options: EmblaOptionsType = {
    breakpoints: {
      '(min-width: 0px)': {
        align: 'start',
        slidesToScroll: 1,
      },
      '(min-width: 640px)': {
        align: 'start',
        slidesToScroll: 2,
      },
      '(min-width: 910px)': {
        align: 'start',
        slidesToScroll: 3,
      },
      '(min-width: 1210px)': {
        align: 'start',
        slidesToScroll: 4,
      },
      '(min-width: 1500px)': {
        align: 'start',
        slidesToScroll: 5,
      },
    },
    slidesToScroll: 3,
  };

  let cardData;
  let theTitle;

  const catsData = [
    {
      title: t('ob.favouritebrands_cats.brand_1.name'),
      lists: [
        t('ob.favouritebrands_cats.brand_1.usp.text_1'),
        t('ob.favouritebrands_cats.brand_1.usp.text_2'),
        t('ob.favouritebrands_cats.brand_1.usp.text_3'),
      ],
      texts: [
        { text: t('ob.product_reco.label'), url: t('ob.favouritebrands_cats.brand_1.usp.link') },
      ],
      image: `${ENV.IMAGE_CDN}/family-brands/OwnBrands_Umbrella_LP_LogoCard_Cosma_C_260x180_INT.jpg`,
    },
    {
      title: t('ob.favouritebrands_cats.brand_2.name'),
      lists: [
        t('ob.favouritebrands_cats.brand_2.usp.text_1'),
        t('ob.favouritebrands_cats.brand_2.usp.text_2'),
        t('ob.favouritebrands_cats.brand_2.usp.text_3'),
      ],
      texts: [
        { text: t('ob.product_reco.label'), url: t('ob.favouritebrands_cats.brand_2.usp.link') },
      ],
      image: `${ENV.IMAGE_CDN}/family-brands/OwnBrands_Umbrella_LP_LogoCard_Purizon_C_260x180_INT.jpg`,
    },
    {
      title: t('ob.favouritebrands_cats.brand_3.name'),
      lists: [
        t('ob.favouritebrands_cats.brand_3.usp.text_1'),
        t('ob.favouritebrands_cats.brand_3.usp.text_2'),
        t('ob.favouritebrands_cats.brand_3.usp.text_3'),
      ],
      texts: [
        { text: t('ob.product_reco.label'), url: t('ob.favouritebrands_cats.brand_3.usp.link') },
      ],
      image: `${ENV.IMAGE_CDN}/family-brands/OwnBrands_Umbrella_LP_LogoCard_Smilla_C_260x180_INT.jpg`,
    },
    {
      title: t('ob.favouritebrands_cats.brand_4.name'),
      lists: [
        t('ob.favouritebrands_cats.brand_4.usp.text_1'),
        t('ob.favouritebrands_cats.brand_4.usp.text_2'),
        t('ob.favouritebrands_cats.brand_4.usp.text_3'),
      ],
      texts: [
        { text: t('ob.product_reco.label'), url: t('ob.favouritebrands_cats.brand_4.usp.link') },
      ],
      image: `${ENV.IMAGE_CDN}/family-brands/OwnBrands_Umbrella_LP_LogoCard_WildFreedom_C_260x180_INT.jpg`,
    },
    {
      title: t('ob.favouritebrands_cats.brand_5.name'),
      lists: [
        t('ob.favouritebrands_cats.brand_5.usp.text_1'),
        t('ob.favouritebrands_cats.brand_5.usp.text_2'),
        t('ob.favouritebrands_cats.brand_5.usp.text_3'),
      ],
      texts: [
        { text: t('ob.product_reco.label'), url: t('ob.favouritebrands_cats.brand_5.usp.link') },
      ],
      image: `${ENV.IMAGE_CDN}/family-brands/OwnBrands_Umbrella_LP_LogoCard_CFL_C_260x180_INT.jpg`,
    },
    {
      title: t('ob.favouritebrands_cats.brand_6.name'),
      lists: [
        t('ob.favouritebrands_cats.brand_6.usp.text_1'),
        t('ob.favouritebrands_cats.brand_6.usp.text_2'),
        t('ob.favouritebrands_cats.brand_6.usp.text_3'),
      ],
      texts: [
        { text: t('ob.product_reco.label'), url: t('ob.favouritebrands_cats.brand_6.usp.link') },
      ],
      image: `${ENV.IMAGE_CDN}/family-brands/OwnBrands_Umbrella_LP_LogoCard_Feringa_C_260x180_INT.jpg`,
    },
    {
      title: t('ob.favouritebrands_cats.brand_7.name'),
      lists: [
        t('ob.favouritebrands_cats.brand_7.usp.text_1'),
        t('ob.favouritebrands_cats.brand_7.usp.text_2'),
        t('ob.favouritebrands_cats.brand_7.usp.text_3'),
      ],
      texts: [
        { text: t('ob.product_reco.label'), url: t('ob.favouritebrands_cats.brand_7.usp.link') },
      ],
      image: `${ENV.IMAGE_CDN}/family-brands/OwnBrands_Umbrella_LP_LogoCard_Tigerino_C_260x180_INT.jpg`,
    },
  ];

  const dogsData = [
    {
      title: t('ob.favouritebrands_dogs.brand_1.name'),
      lists: [
        t('ob.favouritebrands_dogs.brand_1.usp.text_1'),
        t('ob.favouritebrands_dogs.brand_1.usp.text_2'),
        t('ob.favouritebrands_dogs.brand_1.usp.text_3'),
      ],
      texts: [
        { text: t('ob.product_reco.label'), url: t('ob.favouritebrands_dogs.brand_1.usp.link') },
      ],
      image: `${ENV.IMAGE_CDN}/family-brands/OwnBrands_Umbrella_LP_LogoCard_WOW_D_260x180_INT.jpg`,
    },
    {
      title: t('ob.favouritebrands_dogs.brand_2.name'),
      lists: [
        t('ob.favouritebrands_dogs.brand_2.usp.text_1'),
        t('ob.favouritebrands_dogs.brand_2.usp.text_2'),
        t('ob.favouritebrands_dogs.brand_2.usp.text_3'),
      ],
      texts: [
        { text: t('ob.product_reco.label'), url: t('ob.favouritebrands_dogs.brand_2.usp.link') },
      ],
      image: `${ENV.IMAGE_CDN}/family-brands/OwnBrands_Umbrella_LP_LogoCard_Rocco_D_260x180_INT.jpg`,
    },
    {
      title: t('ob.favouritebrands_dogs.brand_3.name'),
      lists: [
        t('ob.favouritebrands_dogs.brand_3.usp.text_1'),
        t('ob.favouritebrands_dogs.brand_3.usp.text_2'),
        t('ob.favouritebrands_dogs.brand_3.usp.text_3'),
      ],
      texts: [
        { text: t('ob.product_reco.label'), url: t('ob.favouritebrands_dogs.brand_3.usp.link') },
      ],
      image: `${ENV.IMAGE_CDN}/family-brands/OwnBrands_Umbrella_LP_LogoCard_Lukullus_D_260x180_INT.jpg`,
    },
    {
      title: t('ob.favouritebrands_dogs.brand_4.name'),
      lists: [
        t('ob.favouritebrands_dogs.brand_4.usp.text_1'),
        t('ob.favouritebrands_dogs.brand_4.usp.text_2'),
        t('ob.favouritebrands_dogs.brand_4.usp.text_3'),
      ],
      texts: [
        { text: t('ob.product_reco.label'), url: t('ob.favouritebrands_dogs.brand_4.usp.link') },
      ],
      image: `${ENV.IMAGE_CDN}/family-brands/OwnBrands_Umbrella_LP_LogoCard_Purizon_D_260x180_INT.jpg`,
    },
    {
      title: t('ob.favouritebrands_dogs.brand_5.name'),
      lists: [
        t('ob.favouritebrands_dogs.brand_5.usp.text_1'),
        t('ob.favouritebrands_dogs.brand_5.usp.text_2'),
        t('ob.favouritebrands_dogs.brand_5.usp.text_3'),
      ],
      texts: [
        { text: t('ob.product_reco.label'), url: t('ob.favouritebrands_dogs.brand_5.usp.link') },
      ],
      image: `${ENV.IMAGE_CDN}/family-brands/OwnBrands_Umbrella_LP_LogoCard_CFL_D_260x180_INT.jpg`,
    },
    {
      title: t('ob.favouritebrands_dogs.brand_6.name'),
      lists: [
        t('ob.favouritebrands_dogs.brand_6.usp.text_1'),
        t('ob.favouritebrands_dogs.brand_6.usp.text_2'),
        t('ob.favouritebrands_dogs.brand_6.usp.text_3'),
      ],
      texts: [
        { text: t('ob.product_reco.label'), url: t('ob.favouritebrands_dogs.brand_6.usp.link') },
      ],
      image: `${ENV.IMAGE_CDN}/family-brands/OwnBrands_Umbrella_LP_LogoCard_Briantos_D_260x180_INT.jpg`,
    },
  ];

  if (type === 'cats') {
    cardData = catsData;
    theTitle = t('ob.favouritebrands_cats.title');
  } else if (type === 'dogs') {
    cardData = dogsData;
    theTitle = t('ob.favouritebrands_dogs.title');
  } else {
    cardData = [];
  }

  return (
    <section>
      <H2 className={styles.title}>{theTitle} </H2>
      <CarouselBeta
        id="cats-brands-carousel"
        nextButtonAriaLabel="next"
        previousButtonAriaLabel="previous"
        className={styles.familyBrands}
        emblaOptions={options}
        gap={'12px'}>
        {cardData.map((card, index) => (
          <CarouselSlideBeta key={`the-key-${index}`} data-testid={`the-key-id-${index}`}>
            <PetsItem texts={card.texts} image={card.image} lists={card.lists} title={card.title} />
          </CarouselSlideBeta>
        ))}
      </CarouselBeta>
    </section>
  );
};

export default PetsFamily;
